module.exports = __webpack_public_path__ + "img/21CreekRoad_Small.141c6e98.png";